/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataStructureGraphIcon20Light = forwardRef('DataStructureGraphIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5a3 3 0 0 1 3-3h7a3 3 0 1 1 0 6H9.508l2.23 3H15a3 3 0 1 1 0 6H8a3 3 0 1 1 0-6h2.492l-2.23-3H5a3 3 0 0 1-3-3Zm3-2a2 2 0 1 0 0 4h7a2 2 0 1 0 0-4H5Zm3 9a2 2 0 1 0 0 4h7a2 2 0 1 0 0-4H8Z" })));
});
